import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { EntityTypographyGroup } from 'src/editor/shared/settings/wrappers/entity-and-website-typography-group/entity-typography-group'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

interface WebsiteLogoSettingsTextProps {
  entity: WebsiteLogoInterface
}

export const WebsiteLogoSettingsText = ({
  entity,
}: WebsiteLogoSettingsTextProps) => {
  const updateProp = useUpdateProp(entity)
  const { t } = useTranslation()
  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <TextInputControl
        update={updateProp('logoText')}
        value={entity.logoText}
        placeholder={t('website_settings.sidebar.logo.label')}
        wrapperProps={{
          labelText: t('website_settings.sidebar.logo.add_text'),
          className: 'mt-6',
        }}
        directionRow
      />
      <EntityTypographyGroup
        entity={entity}
        hideTextAlign
        hideFontSelector={isMobile}
        hideLetterSpacing={isMobile}
      />
      {!isMobile && (
        <ColorPickerControl
          label="website_settings.sidebar.logo.text_color"
          update={updateProp('textColor')}
          color={entity.textColor}
          singleColorMode
        />
      )}
    </>
  )
}
